import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-209" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-earth-200 border-l-4 border-l-gold-500 bg-white p-4 pr-10 text-ink shadow-2xl shadow-earth-700/20" aria-live="polite" data-id="element-210" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-forest-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400" aria-label="Dismiss notice" data-id="element-211" data-mp="1sdtidkdlzmvm">
            <XIcon className="h-4 w-4" data-id="element-212" data-mp="19owlr9uqoia8" />
          </button>
          <div className="flex gap-3" data-id="element-213" data-mp="19nbtxrzt7dg2">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-forest-600" aria-hidden="true" data-id="element-214" data-mp="1egn3i0w0a8bo" />
            <div data-id="element-215" data-mp="zrqua0i7qp9h">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-earth-500" data-id="element-216" data-mp="zsa752t0angn">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-217" data-mp="14qv854g31b65">
                Once your purchase is complete you receive the
                <br data-id="element-218" data-mp="vpnjle3dbop9" />
                <span className="font-bold text-forest-900" data-id="element-219" data-mp="vq5cq1uqhmsy">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-220" data-mp="2xfco4wxdq6rx">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}